function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "gallery-arrow-left_svg__a",
  d: "M13.171 32l11.784 11.739L36.857 32.09 40 35.247 24.928 50 10 35.129z"
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v82H0z",
  opacity: 0.3,
  fill: "#2B2B2B"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  transform: "rotate(90 25 41)",
  xlinkHref: "#gallery-arrow-left_svg__a"
}));
function SvgGalleryArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}
export default SvgGalleryArrowLeft;